import { render, staticRenderFns } from "./CollectionHistoryTable.vue?vue&type=template&id=4ae4e8bc&"
import script from "./CollectionHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionHistoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports